import script from "./SupportConversationAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportConversationAdmin.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/SupportConversationAdmin.css?vue&type=style&index=0&id=eaa2f03a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaa2f03a"]])

export default __exports__